import Footer from "../components/footer";
import SideNav from "../components/sidenav"
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import { useNavigate } from "react-router-dom";


const MyOrderArtist = () => {
    
    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const navigate = useNavigate();
    const [dataOrderList, setDataOrderList] = useState([]);

        // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/OrderList/Get-GetAllSaleDetailsByArtistID?artist_id='+ userInfo.user_id, setDataOrderList);

    }, [dataOrderList]);

    const columns = [
        
        {
            name: "Artwork",
            cell: (row) => <img className="m-2" src={`../images/products/full/${row.imageURL}`} alt=" " width="80px" />,
            width: "150px",
        },
        {
            name: "Title",
            selector: (row) => row.productName,
            width: "200px"
        }, 
        {
            name: "Buyer",
            selector: (row) => row.buyerName,
            width: "160px"
        },
        {
            name: "Sale On",
            selector: row => new Date(row.createdOn).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            sortable: true,
            width: "120px",
        }
    ];
 
    
    
    
    return (
        <div>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <PageHeader name='My Order List' icon='bi bi-suit-heart-fill' />
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">My Order List</div>
                                        <div className="card-body">

                                        <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={dataOrderList}
                                                    pagination
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default MyOrderArtist;